import type Polyglot from "node-polyglot"

export const defaultPolyglot: Polyglot = {
  // returns a zero width space
  t: () => "\u200B",
  extend: () => ({}),
  unset: () => ({}),
  locale: (locale?: string) => locale ?? "en",
  clear: () => ({}),
  replace: () => ({}),
  has: () => false,
}
